import React from 'react';
import hasParentWithClassName from '@lib/hasParentWithClassName'

export default class Dropdown extends React.Component {
    state = {
        open: false
    }

    onButtonClick = e => {
        if (this.props.disabled) {
            return;
        }

        this.setState({
            open: !this.state.open
        })

        if (!this.state.open) {
            window.addEventListener('click', this.onWindowClick)
        } else {
            window.removeEventListener('click', this.onWindowClick)
        }
    }

    onItemClick = item => {
        if (this.props.onItemClick) {
            this.props.onItemClick(item)
        }

        this.setState({open: false})
        window.removeEventListener('click', this.onWindowClick)
    }

    onWindowClick = e => {
        if (!hasParentWithClassName(e.target, 'dropdown--react')) {
            this.setState({open: false})
            window.removeEventListener('click', this.onWindowClick)
        }
    }

    renderButton() {
        const DropdownIcon = this.props.icon;

        return (
            <div className="dropdown-button" onClick={this.onButtonClick}>
                <div className="dropdown-button-body">
                    {this.props.icon && (
                        <span className="dropdown-button-icon">
                            <DropdownIcon/>
                        </span>
                    )}

                    {this.renderCaption()}
                </div>

                <div className="dropdown-button-caret">
                    <svg width="12" height="12" viewBox="0 0 12 12">
                        <g fill="none" fillRule="evenodd">
                            <path fill="#9da4b3"
                                  d="M11.606 3.599l-.386-.389a.64.64 0 0 0-.457-.188.641.641 0 0 0-.456.188L5.9 7.617 1.488 3.205a.64.64 0 0 0-.457-.188.64.64 0 0 0-.456.188l-.386.387a.646.646 0 0 0 0 .912l5.253 5.272a.66.66 0 0 0 .457.207h.002a.66.66 0 0 0 .457-.207l5.248-5.258a.652.652 0 0 0 0-.919z"/>
                        </g>
                    </svg>
                </div>
            </div>
        )
    }

    renderCaption = () => this.props.renderCaption ? this.props.renderCaption() : this.props.caption

    render() {
        const renderItemIcon = item => {
            const ItemComponent = item.icon;
            return <ItemComponent/>;
        }

        const classes = ['dropdown dropdown--react'];
        if (this.state.open) {
            classes.push('dropdown--open');
        }

        if (this.props.disabled) {
            classes.push('dropdown--disabled')
        }

        return (
            <div className={classes.join(' ')}>
                {this.renderButton()}

                <div className="dropdown-body" style={{display: this.state.open ? 'block' : 'none'}}>
                    {this.props.items.map(item => (
                        <div key={item.id} className="dropdown-item" onClick={() => this.onItemClick(item)}>
                            {item.icon && (
                                <span className="dropdown-item-icon">
                                    {renderItemIcon(item)}
                                </span>
                            )}

                            {item.label}
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}